/**
 * logout.js
 * Written by: Alex Kasemir
 */

import { formatAxiosError } from 'utils';
import request from '../../../request/actions';
import event, { resetUserId } from '../../../../utils/event';

import { removeToken } from '../removeToken';

export const LOGOUT_START = `LOGOUT_START`;
export const LOGOUT_SUCCESS = `LOGOUT_SUCCESS`;
export const LOGOUT_FAILURE = `LOGOUT_FAILURE`;

export const logoutStart = () => ({
  type: LOGOUT_START,
});

export const logoutSuccess = () => ({
  type: LOGOUT_SUCCESS,
});

export const logoutFailure = (error) => ({
  type: LOGOUT_FAILURE,
  error,
});

/**
 * Description of the logout action
 */
export const logout = () => {
  return async (dispatch) => {
    dispatch(logoutStart());
    dispatch(removeToken());
    resetUserId();

    try {
      await dispatch(request(`/auth/logout/`, `POST`));
      event(`user-logout`, [`click`, `user-logout`]);
      dispatch(logoutSuccess());
    } catch (e) {
      event(`user-logout-failure`, [`error`, `user-logout-failure`]);
      dispatch(logoutFailure(e));
      if (e instanceof Error) {
        throw e;
      }
      const errMsg = formatAxiosError(`logout`, e);
      throw new Error(errMsg);
    }
  };
};

export default logout;
